import React, { useEffect, useState } from "react";
import { fetchApi } from "../helper/api";
import { IsAlert } from "../component/atoms/IsAlert";
import { Link } from "react-router-dom";
import InputUser from "../component/molecules/popup/InputUser";
import EditUser from "../component/molecules/popup/EditUser";
import EditRole from "../component/molecules/popup/EditRole";
const $ = require("jquery");
$.Datatable = require("datatables.net");

class UserManagememtRole extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
      dataEdit: null,
    };
  }
  componentDidMount() {
    this.getdata(function () {});
    // this.setDefaultDate()
  }
  getdata = async () => {
    const req = await fetchApi("api/Role", "GET", true);
    // var req = await fetch("https://jsonplaceholder.typicode.com/users")
    const res = await req.json();
    const status = req.status;
    // console.log("DATA: ", res.data.response);
    this.setState({ data: res.data.response }, function () {
      this.setDatatable();
    });
  };

  setDatatable = () => {
    const self = this;
    this.$el = $(this.el);
    this.$el.DataTable({
      bLengthChange: false,
      bInfo: true,
      language: { searchPlaceholder: "Search...", search: "" },
      bDestroy: true,
      data: this.state.data,
      columns: [
        {
          width: 20,
          title: "No",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return meta.row + 1;
          },
        },
        {
          title: "Nama",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return data.namaRole;
          },
        },
        {
          title: "Deskripsi",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return data.desc;
          },
        },
        {
          width: 190,
          title: "Opsi",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return `<div class="d-flex">
                                    <button class="btn btn-info d-flex align-items-center editData text-nowrap mr-1" data-toggle="modal" data-target="#EditRole_modal" data-namarole="${data.namaRole}" data-desc="${data.desc}" data-id="${data.idRole}">
                                        <i class="las la-edit text-white" style="font-size: 20px"></i>
                                    </button>
                                </div>
                            `;
          },
        },
      ],
    });

    $(".editData").click(function (e) {
      e.preventDefault();
      // const { id } = e.target;
      const namaRole = $(this).data("namarole");
      const desc = $(this).data("desc");
      const roleId = $(this).data("id");
      // console.log("DATA", data);
      self.setState({
        dataEdit: { namaRole: namaRole, desc: desc, roleId: roleId },
      });
      // self.props.router.push("/on-boarding/calon-agen/123/data-calon-agen");
    });
    $(".deleteData").click(function (e) {
      e.preventDefault();
      IsAlert.fire({
        title: "",
        text: "Apakah anda yakin untuk menghapus role ini?",
        icon: "warning",
        showCancelButton: true,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          // navigate("/login")
        }
      });
    });
    var anu = $(".dataTables_filter");
    $(".wadah").html(anu);
  };

  render() {
    return (
      <div className="p-2">
        <EditRole
          dataEdit={this.state.dataEdit}
          // reloadData={() => console.log("R`ELOAD DATA")}
        />
        <div className="d-flex align-items-center justify-content-between mb-4">
          <h1 className="mb-0">Hak Akses</h1>
        </div>
        <div className="box bg-white rounded-banget shadow p-4 table-responsive overflow-x-auto">
          <table
            id="dataCalonAgen"
            className="display table w-100"
            width="100%"
            ref={(el) => (this.el = el)}
          ></table>
        </div>
      </div>
    );
  }
}

export default UserManagememtRole;
